<template>
  <v-app>
    <v-main>
      <v-app-bar app color="#121212" flat>
        <template v-slot:prepend>
          <v-app-bar-nav-icon
            variant="text"
            @click.stop="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </template>
        <v-app-bar-title class="font-weight-bold">Mario Novak</v-app-bar-title>
        <a href="https://www.buymeacoffee.com/moltouni" target="_blank" class="mr-4 mt-2">
          <img src="https://cdn.buymeacoffee.com/buttons/v2/lato-white.png" alt="Buy Me A Coffee" style="max-height: 42px !important;">
        </a>
      </v-app-bar>
      <v-navigation-drawer
        v-model="drawer"
        :location="$vuetify.display.mobile ? 'bottom' : undefined"
        :color="$vuetify.display.mobile ? 'black' : 'rgba(0,0,0,0)'"
        style="border: none !important; box-shadow: none !important; z-index: 999999;"
        temporary
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :href="item.value"
          :title="item.title"
        ></v-list-item>
      </v-navigation-drawer>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',

  data () {
    return {
      drawer: false,
      items: [
        {
          title: 'Introduction',
          value: '#Introduction',
        },
        {
          title: 'Apps',
          value: '#Apps',
        },
        {
          title: 'Essays',
          value: '#Essays',
        },
        {
          title: 'Podcasts',
          value: '#Podcasts',
        },
        {
          title: 'Projects',
          value: '#Projects',
        },
        {
          title: 'Contact',
          value: '#Contact',
        },
      ]
    }
  },
})
</script>
